// extracted by mini-css-extract-plugin
export var aboutContainer = "footer-module--aboutContainer--6165f";
export var footer = "footer-module--footer--2b30a";
export var quickLinks = "footer-module--quickLinks--5b355";
export var quickLinksContainer = "footer-module--quickLinksContainer--758fe";
export var title = "footer-module--title--13230";